import React from "react";
import dashboardMock from "../../../../assets/images/dashboard-mock.png";

export default function DashboardSection() {
  return (
    <section className="section-py">
      <div className="container-selectezi">
        <div className="section-head">
          <span className="eyebrow-label">Platform Visibility</span>
          <h2 className="section-title">
            Marketing Agent Dashboard &amp; <br></br>Business Owner Transparency
          </h2>
          <p className="section-subtitle mx-auto">
            Complete accountability with transparent operational metrics
            visible to both agent and business owner.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="dashboard-frame">
              <img src={dashboardMock} alt="Marketing Agent dashboard showing package progress metrics" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
